(() => {
  const banner = document.querySelector('[data-hs-privacy-banner]');
  if (!banner || !window.Shopify?.customerPrivacy) return;
  const privacy = window.Shopify.customerPrivacy;
  const show = () => {
    if (privacy.shouldShowBanner?.()) banner.hidden = false;
  };
  document.addEventListener('visitorConsentCollected', () => { banner.hidden = true; });
  banner.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-hs-consent]')?.dataset.hsConsent;
    if (!choice) return;
    const accepted = choice === 'accept';
    privacy.setTrackingConsent(
      { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: false },
      () => { banner.hidden = true; },
    );
  });
  show();
})();
